__turbopack_context__.v({
  "darkroom": "real-footer-module__jkOnAa__darkroom",
  "footer": "real-footer-module__jkOnAa__footer",
  "lines": "real-footer-module__jkOnAa__lines",
  "stickyWrapper": "real-footer-module__jkOnAa__stickyWrapper",
  "wrapper": "real-footer-module__jkOnAa__wrapper",
});
